import { PrimevalLegacy } from '@apeiron/planet'
import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'
import { primevalLegaciesSchema } from '@src/deserialize/yup/planet'

const useFetchPlanetPrimevalJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  return useReactQueryFetchJson<PrimevalLegacy[]>({
    fetchNow,
    path: ENV_CONFIG.JSON_FILE_NAME.PRIMEVAL_LEGACY,
    deserialize: response =>
      primevalLegaciesSchema.cast(response) as PrimevalLegacy[]
  })
}

export default useFetchPlanetPrimevalJson
